module.exports = __webpack_public_path__ + "img/icon_--_tracking.e6e53c4e.png";